import { Star } from "lucide-react";
import { testimonials } from "@/lib/siteData";
import { Reveal } from "./Primitives";

export const Testimonials = () => (
  <section id="depoimentos" className="relative border-y border-white/5 bg-[#0F0F1A]/50 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal className="mb-16">
        <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-cyan-400">// Depoimentos</span>
        <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter md:text-5xl">
          Quem assina, recomenda
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <div
              data-testid={`testimonial-${i}`}
              className={`h-full rounded-2xl border border-white/8 bg-gradient-to-br from-[#12121f] to-[#05050A] p-6 transition-transform duration-300 hover:rotate-0 hover:scale-[1.03] ${t.rot}`}
            >
              <div className="mb-4 flex gap-1">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-[#8B5CF6] text-[#8B5CF6]" />
                ))}
              </div>
              <p className="font-body text-slate-200">"{t.text}"</p>
              <div className="mt-6">
                <div className="font-display font-bold">{t.name}</div>
                <div className="font-mono-accent text-xs uppercase tracking-widest text-slate-500">{t.role}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
